import { BotElement } from '../types/model-types';
import { GotoElement } from '../types/serialized-types';


@BotElement.register("goto")
class Goto extends BotElement {
    goto: string = "";
    withNextItemFrom: string | null = null;

    static fromJSON(obj: GotoElement): Goto {
        let g = new Goto(obj.type);
        g.if = obj.if || null;
        g.id = obj.id || null;
        g.goto = obj.goto;
        g.withNextItemFrom = obj["with-next-item-from"] || null;
        return g;
    }
}


export {
    Goto
}
